export default __webpack_public_path__ + "static/DettolSansWeb-Regular-d259399412f3faddab6d4667dca043ee.woff2";